var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ApiUrls } from '../../../enums/api-endpoint/controller.api-endpoint';
import { FileApiEndpoints } from '../../../enums/api-endpoint/file-api-endpoints';
import { StandardType } from '../../../enums/standard-type';
var OrderListComponent = /** @class */ (function () {
    function OrderListComponent() {
        this.title = '';
        this.items = [];
        this.isReadonly = false;
        this.basketId = 0;
        this.dismissClicked = new EventEmitter();
        this.viewModel = {
            downloadAltText: 'Download file',
            apprenticeshipType: StandardType.Apprenticeship,
            bespokeType: StandardType.Bespoke,
            regulatedType: StandardType.Regulated,
            functionalSkillStandardType: StandardType.FunctionalSkill
        };
    }
    OrderListComponent.prototype.onDismissClick = function (standard) {
        this.dismissClicked.emit(standard);
    };
    OrderListComponent.prototype.downloadAttachedFile = function (fileName, standardId) {
        if (this.basketId) {
            var route = "" + ApiUrls.File + FileApiEndpoints.Download + "/" + this.basketId + "/" + fileName + "/" + standardId;
            window.open(route, '_blank');
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], OrderListComponent.prototype, "title", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], OrderListComponent.prototype, "items", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], OrderListComponent.prototype, "isReadonly", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], OrderListComponent.prototype, "basketId", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], OrderListComponent.prototype, "dismissClicked", void 0);
    OrderListComponent = __decorate([
        Component({
            selector: 'order-list',
            template: require('./order-list.component.html'),
            styles: [require('./order-list.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], OrderListComponent);
    return OrderListComponent;
}());
export { OrderListComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JkZXItbGlzdC5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJvcmRlci1saXN0LmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDekQsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUk3QyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0scURBQXFELENBQUM7QUFDOUUsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFFbEYsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLDhCQUE4QixDQUFDO0FBTzVEO0lBU0k7UUFSZ0IsVUFBSyxHQUFXLEVBQUUsQ0FBQztRQUNuQixVQUFLLEdBQTZCLEVBQUUsQ0FBQztRQUNyQyxlQUFVLEdBQVksS0FBSyxDQUFDO1FBQzVCLGFBQVEsR0FBWSxDQUFDLENBQUM7UUFDckIsbUJBQWMsR0FBbUMsSUFBSSxZQUFZLEVBQW9CLENBQUM7UUFLbkcsSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLGVBQWUsRUFBRSxlQUFlO1lBQ2hDLGtCQUFrQixFQUFFLFlBQVksQ0FBQyxjQUFjO1lBQy9DLFdBQVcsRUFBRSxZQUFZLENBQUMsT0FBTztZQUNqQyxhQUFhLEVBQUUsWUFBWSxDQUFDLFNBQVM7WUFDckMsMkJBQTJCLEVBQUUsWUFBWSxDQUFDLGVBQWU7U0FDNUQsQ0FBQztJQUNOLENBQUM7SUFFTSwyQ0FBYyxHQUFyQixVQUFzQixRQUEwQjtRQUM1QyxJQUFJLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBRU0saURBQW9CLEdBQTNCLFVBQTRCLFFBQWdCLEVBQUUsVUFBa0I7UUFDNUQsSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ2YsSUFBSSxLQUFLLEdBQUcsS0FBRyxPQUFPLENBQUMsSUFBSSxHQUFHLGdCQUFnQixDQUFDLFFBQVEsU0FBSSxJQUFJLENBQUMsUUFBUSxTQUFJLFFBQVEsU0FBSSxVQUFZLENBQUM7WUFDckcsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLENBQUM7U0FDaEM7SUFDTCxDQUFDO0lBM0JRO1FBQVIsS0FBSyxFQUFFOztxREFBMkI7SUFDMUI7UUFBUixLQUFLLEVBQUU7O3FEQUE2QztJQUM1QztRQUFSLEtBQUssRUFBRTs7MERBQW9DO0lBQ25DO1FBQVIsS0FBSyxFQUFFOzt3REFBOEI7SUFDNUI7UUFBVCxNQUFNLEVBQUU7a0NBQXdCLFlBQVk7OERBQTBEO0lBTDlGLGtCQUFrQjtRQUw5QixTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsWUFBWTtZQUN0QixRQUFRLEVBQUUsT0FBTyxDQUFDLDZCQUE2QixDQUFDO1lBQ2hELE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQyw2QkFBNkIsQ0FBQyxDQUFDO1NBQ25ELENBQUM7O09BQ1csa0JBQWtCLENBNkI5QjtJQUFELHlCQUFDO0NBQUEsQUE3QkQsSUE2QkM7U0E3Qlksa0JBQWtCIn0=